import { render, staticRenderFns } from "./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=template&id=600a6342&scoped=true"
import script from "./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=script&lang=ts"
export * from "./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=script&lang=ts"
import style0 from "./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=style&index=0&id=600a6342&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a6342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600a6342')) {
      api.createRecord('600a6342', component.options)
    } else {
      api.reload('600a6342', component.options)
    }
    module.hot.accept("./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=template&id=600a6342&scoped=true", function () {
      api.rerender('600a6342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/EditDefaultImportSaleRowDescriptionTemplate.vue"
export default component.exports